import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  readonly isShowNotification = signal(false);

  setNotificationState(state: boolean): void {
    this.isShowNotification.set(state);
  }
}
